import type { BrandConfig } from 'store/modules/brandConfig/types'

export const fetchBrandConfig = async (): Promise<BrandConfig | null> => {
  try {
    const response = await fetch(`${process.env.CONFIG_API_URL}?brandName=${process.env.BRAND_NAME}`)
    if (!response.ok) {
      console.warn(`HTTP error! status: ${response.status}`)

      return null
    }
    const data = await response.json()

    return data as BrandConfig
  } catch (error) {
    console.error('Error fetching brand config:', error)

    return null
  }
}
